import {Injectable} from "@angular/core";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export abstract class DeviceWS {
  abstract execute(deviceId: string): Observable<void>
}
